<template>
	<div class="flex flex_center position_relative">
		<md-field :class="[{ 'md-error': error }]">
			<label>{{ labelText }}</label>
			<TbSelect v-model="moduleValue"
					  @md-selected="onSelect"
					  :search-allow="true"
					  :search-custom="true"
					  @search="onSearch"
					  :options="filteredOptions"
					  options-value-field="code"
					  options-key-field="key"
					  options-display-field="name"
					  :disabled="disabled"
					  :required="required"
			/>
			<span v-if="error" class="validation-error">{{ error }}</span>
		</md-field>
		<el-tooltip v-if="tooltipText" :content="tooltipText" :placement="tooltipPlacement" class="tooltip-icon">
			<i class="fa fa-info-circle secondary_color" aria-hidden="true"></i>
		</el-tooltip>
	</div>
</template>
<script>
import {commonApi} from "@/common/api/commonApi";
import {enumDef} from "@/common/enumDefs";

export default {
	props: {
		labelText: { type: String },
		disabled: { type: Boolean, default: false },
		required: { type: Boolean, default: false },
		error: { type: Boolean, default: "" },
		value: { type: String, default: "" },
		companyType: { type: Number | null, default: enumDef.companyType.TraderCompany },
		tooltipText: { type: String, default: null },
		tooltipPlacement: { type: String, default: "top" },
		excludes: { type: Array, default: [] },
		traderType: { type: Number },
		deOnTop: { type: Boolean, default: true },
	},
	data() {
		return {
			moduleValue: "",
			searchValue: "",
			options: []
		};
	},
	mounted() {
		this.moduleValue = this.value;
		this.getList();
	},
	methods: {
		onSelect() {
			this.$emit("input", this.moduleValue);
		},
		getList() {
			if (this.companyType) {
				commonApi.Companycountries(this.companyType, this.traderType)
					.then(this.setOptions)
					.catch();
			} else {
				commonApi.countries()
					.then(this.setOptions)
					.catch();
			}
		},
		setOptions(options) {
			this.options = options
				// Remove specially excluded countries
				.filter(item => !this.excludes.includes(item.code))
				// Translate the country code and prepare key values to allow multiple entries for the same country,
				// e.g. when DE is also included at the top
				.map(item => {
					return {
						...item,
						key: item.code,
						name: this.$t(item.translationKey || ("common.country." + item.code))
					};
				})
				// Sort by country name
				.sort((c1, c2) => c1.name.localeCompare(c2.name));
		},
		onSearch(searchValue) {
			this.searchValue = searchValue;
		},
	},
	computed: {
		filteredOptions() {
			let { options, value, searchValue } = this;

			// Put germany on the top of the list if it is not already on the top, is not selected and the list is unfiltered
			if (this.deOnTop && !searchValue && value !== "DE" && (options.length > 5 && options[0].code !== "DE")) {
				return [{ code: "DE", name: this.$t("common.country.DE"), key: "DE_top" }].concat(options);
			} else { // Filter list by search value
				return options.filter(item => item.name.toLowerCase()
					.includes(searchValue.toLowerCase()));
			}
		}
	},
	watch: {
		value() {
			this.moduleValue = this.value;
			this.getList();
		}
	}
};
</script>

<style lang="scss" scoped>
.tooltip-icon {
	position: absolute;
	right: -1rem;
}
</style>
